export default {"src":"/_next/static/media/2.6b3f5e41.svg","height":38,"width":38,"blurWidth":0,"blurHeight":0};